import React, { useState } from 'react';
import Icon from '../AppIcon';
import { supabase } from '../../lib/supabase';



// Action-specific modals and handlers
const LegalReviewModal = ({ isOpen, onClose, contract, actionColor }) => {
  const [reviewNotes, setReviewNotes] = useState('');
  const [complianceChecks, setComplianceChecks] = useState({
    propertyLaws: false,
    tenancyRules: false,
    financialTerms: false,
    disputeResolution: false
  });

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-black rounded-md shadow-2xl border w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
        style={{
          borderColor: '#FFFFFF',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">المراجعة القانونية</h3>
            <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-md transition-colors">
              <Icon name="X" size={20} color="#FFFFFF" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="bg-white/5 rounded-md p-4 border border-white/12">
              <h4 className="text-white font-semibold mb-3 text-right">فحص الامتثال القانوني</h4>
              {Object.entries(complianceChecks)?.map(([key, value]) => (
                <label key={key} className="flex items-center gap-3 mb-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={value}
                    onChange={(e) => setComplianceChecks(prev => ({ ...prev, [key]: e?.target?.checked }))}
                    className="w-5 h-5 rounded"
                  />
                  <span className="text-white/90 text-right flex-1">
                    {key === 'propertyLaws' ? 'قوانين الملكية العقارية' :
                     key === 'tenancyRules' ? 'أنظمة الإيجار والتأجير' :
                     key === 'financialTerms'? 'الشروط المالية والضريبية' : 'آليات حل النزاعات'}
                  </span>
                </label>
              ))}
            </div>

            <div>
              <label className="text-white font-semibold mb-2 block text-right">ملاحظات المراجعة</label>
              <textarea
                value={reviewNotes}
                onChange={(e) => setReviewNotes(e?.target?.value)}
                className="w-full h-28 bg-white/5 border border-white/20 rounded-md p-3 text-white text-right"
                placeholder="أضف ملاحظاتك القانونية هنا..."
                dir="rtl"
              />
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => {
                  console.log('Legal approval:', { complianceChecks, reviewNotes });
                  onClose();
                }}
                className="flex-1 py-2.5 rounded-md font-semibold text-black bg-white hover:bg-white/90 transition-colors">
                <Icon name="CheckCircle" size={18} color="#000" className="inline ml-2" />
                اعتماد قانوني
              </button>
              <button
                onClick={() => {
                  console.log('Request amendments:', { reviewNotes });
                  onClose();
                }}
                className="flex-1 py-2.5 rounded-md font-semibold text-white bg-white/10 hover:bg-white/15 border border-white/20 transition-colors">
                <Icon name="AlertTriangle" size={18} color="#FFF" className="inline ml-2" />
                طلب تعديلات
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const ApprovalModal = ({ isOpen, onClose, contract, actionColor }) => {
  const [approvalNotes, setApprovalNotes] = useState('');
  const [approvalLevel, setApprovalLevel] = useState('manager');

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
        style={{
          borderColor: actionColor || '#10B981',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">الموافقة والاعتماد</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="text-white font-semibold mb-2 block text-right">مستوى الموافقة</label>
              <select
                value={approvalLevel}
                onChange={(e) => setApprovalLevel(e?.target?.value)}
                className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                dir="rtl">
                <option value="manager">مدير القسم</option>
                <option value="director">المدير التنفيذي</option>
                <option value="ceo">الإدارة العليا</option>
              </select>
            </div>

            <div>
              <label className="text-white font-semibold mb-2 block text-right">ملاحظات الموافقة</label>
              <textarea
                value={approvalNotes}
                onChange={(e) => setApprovalNotes(e?.target?.value)}
                className="w-full h-28 bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                placeholder="أضف ملاحظاتك الإدارية..."
                dir="rtl"
              />
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => {
                  console.log('Approved:', { approvalLevel, approvalNotes });
                  onClose();
                }}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-green-600 hover:bg-green-700 transition-colors">
                <Icon name="ThumbsUp" size={18} color="#FFF" className="inline ml-2" />
                الموافقة
              </button>
              <button
                onClick={() => {
                  console.log('Rejected:', { approvalNotes });
                  onClose();
                }}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-red-600 hover:bg-red-700 transition-colors">
                <Icon name="ThumbsDown" size={18} color="#FFF" className="inline ml-2" />
                الرفض
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const DigitalSigningModal = ({ isOpen, onClose, contract, actionColor }) => {
  const [signatories, setSignatories] = useState([
    { name: 'المالك', email: 'owner@example.com', signed: false },
    { name: 'المستأجر', email: 'tenant@example.com', signed: false },
    { name: 'الشاهد', email: 'witness@example.com', signed: false }
  ]);

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
        style={{
          borderColor: actionColor || '#3B82F6',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">التوقيع الإلكتروني</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="bg-gray-800/50 rounded-lg p-4">
              <h4 className="text-white font-semibold mb-3 text-right">الأطراف الموقعة</h4>
              {signatories?.map((signatory, index) => (
                <div key={index} className="flex items-center justify-between mb-3 pb-3 border-b border-gray-700 last:border-0">
                  <div className="text-right flex-1">
                    <p className="text-white font-medium">{signatory?.name}</p>
                    <p className="text-gray-400 text-sm">{signatory?.email}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    {signatory?.signed ? (
                      <span className="text-green-400 flex items-center gap-1">
                        <Icon name="CheckCircle" size={18} color="#10B981" />
                        موقع
                      </span>
                    ) : (
                      <button
                        onClick={() => {
                          const updated = [...signatories];
                          updated[index].signed = true;
                          setSignatories(updated);
                        }}
                        className="px-3 py-1 bg-blue-600 hover:bg-blue-700 rounded text-white text-sm transition-colors">
                        إرسال للتوقيع
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => {
                console.log('Send reminders to unsigned parties');
              }}
              className="w-full py-2.5 rounded-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors">
                <Icon name="Mail" size={18} color="#FFF" className="inline ml-2" />
                إرسال تذكير للأطراف
              </button>
          </div>
        </div>
      </div>
    </>
  );
};

const ExecutionModal = ({ isOpen, onClose, contract, actionColor }) => {
  const [paymentSchedule, setPaymentSchedule] = useState([
    { date: '2026-02-01', amount: '30,000', status: 'pending' },
    { date: '2026-05-01', amount: '30,000', status: 'pending' },
    { date: '2026-08-01', amount: '30,000', status: 'pending' },
    { date: '2026-11-01', amount: '30,000', status: 'pending' }
  ]);

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
        style={{
          borderColor: actionColor || '#8B5CF6',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">تنفيذ العقد</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="bg-gray-800/50 rounded-lg p-4">
              <h4 className="text-white font-semibold mb-3 text-right">جدول الدفعات</h4>
              {paymentSchedule?.map((payment, index) => (
                <div key={index} className="flex items-center justify-between mb-3 pb-3 border-b border-gray-700 last:border-0">
                  <div className="text-right flex-1">
                    <p className="text-white font-medium">{payment?.date}</p>
                    <p className="text-gray-400 text-sm">{payment?.amount} ريال</p>
                  </div>
                  <span className={`px-3 py-1 rounded text-sm ${
                    payment?.status === 'paid' ? 'bg-green-600/20 text-green-400' : 'bg-yellow-600/20 text-yellow-400'
                  }`}>
                    {payment?.status === 'paid' ? 'مدفوع' : 'معلق'}
                  </span>
                </div>
              ))}
            </div>

            <button
              onClick={() => {
                console.log('Execute contract');
                onClose();
              }}
              className="w-full py-2.5 rounded-lg font-semibold text-white bg-purple-600 hover:bg-purple-700 transition-colors">
                <Icon name="PlayCircle" size={18} color="#FFF" className="inline ml-2" />
                تنفيذ العقد
              </button>
          </div>
        </div>
      </div>
    </>
  );
};

const RenewalModal = ({ isOpen, onClose, contract, actionColor }) => {
  const [renewalTerms, setRenewalTerms] = useState({
    newRent: '',
    duration: '12',
    priceIncrease: '',
    startDate: ''
  });

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
        style={{
          borderColor: actionColor || '#06B6D4',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">تجديد العقد</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">الإيجار الجديد</label>
                <input
                  type="text"
                  value={renewalTerms?.newRent}
                  onChange={(e) => setRenewalTerms(prev => ({ ...prev, newRent: e?.target?.value }))}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-purple-500"
                  placeholder="دينار أردني"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">نسبة الزيادة</label>
                <input
                  type="text"
                  value={renewalTerms?.priceIncrease}
                  onChange={(e) => setRenewalTerms(prev => ({ ...prev, priceIncrease: e?.target?.value }))}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-purple-500"
                  placeholder="%"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">المدة (أشهر)</label>
                <select
                  value={renewalTerms?.duration}
                  onChange={(e) => setRenewalTerms(prev => ({ ...prev, duration: e?.target?.value }))}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-purple-500"
                  dir="rtl">
                  <option value="6">6 أشهر</option>
                  <option value="12">12 شهر</option>
                  <option value="24">24 شهر</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">تاريخ البدء</label>
                <input
                  type="date"
                  value={renewalTerms?.startDate}
                  onChange={(e) => setRenewalTerms(prev => ({ ...prev, startDate: e?.target?.value }))}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-purple-500"
                />
              </div>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => console.log('Send payment reminder')}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors">
                <Icon name="Bell" size={18} color="#FFF" className="inline ml-2" />
                إرسال تذكير دفع
              </button>
              <button
                onClick={() => console.log('Add amendment')}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-purple-600 hover:bg-purple-700 transition-colors">
                <Icon name="FileEdit" size={18} color="#FFF" className="inline ml-2" />
                إضافة ملحق
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const TerminationModal = ({ isOpen, onClose, contract, actionColor }) => {
  const [terminationData, setTerminationData] = useState({
    reason: '',
    terminationDate: '',
    penalty: '',
    refundAmount: ''
  });

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
        style={{
          borderColor: actionColor || '#EF4444',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">إنهاء العقد</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">سبب الإنهاء</label>
              <textarea
                value={terminationData?.reason}
                onChange={(e) => setTerminationData(prev => ({ ...prev, reason: e?.target?.value }))}
                className="w-full h-24 bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-purple-500 text-right"
                placeholder="اذكر سبب إنهاء العقد..."
                dir="rtl"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">تاريخ الإنهاء</label>
                <input
                  type="date"
                  value={terminationData?.terminationDate}
                  onChange={(e) => setTerminationData(prev => ({ ...prev, terminationDate: e?.target?.value }))}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-purple-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">الغرامة (دينار أردني)</label>
                <input
                  type="text"
                  value={terminationData?.penalty}
                  onChange={(e) => setTerminationData(prev => ({ ...prev, penalty: e?.target?.value }))}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-purple-500"
                  placeholder="0"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">المبلغ المسترد (دينار أردني)</label>
              <input
                type="text"
                value={terminationData?.refundAmount}
                onChange={(e) => setTerminationData(prev => ({ ...prev, refundAmount: e?.target?.value }))}
                className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-purple-500"
                placeholder="0"
              />
            </div>

            <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4">
              <div className="flex gap-3">
                <Icon name="AlertTriangle" size={20} color="#EF4444" className="flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-red-400 font-medium mb-1">تحذير:</p>
                  <p className="text-sm text-red-300">إنهاء العقد إجراء نهائي ولا يمكن التراجع عنه. يرجى التأكد من جميع البيانات قبل المتابعة.</p>
                </div>
              </div>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => {
                  console.log('Calculate settlement:', terminationData);
                }}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-orange-600 hover:bg-orange-700 transition-colors">
                <Icon name="Calculator" size={18} color="#FFF" className="inline ml-2" />
                حساب التسوية
              </button>
              <button
                onClick={() => {
                  console.log('Terminate contract:', terminationData);
                  onClose();
                }}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-red-600 hover:bg-red-700 transition-colors">
                <Icon name="XCircle" size={18} color="#FFF" className="inline ml-2" />
                إنهاء العقد
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const ArchiveModal = ({ isOpen, onClose, contract, actionColor }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [archiveFilters, setArchiveFilters] = useState({
    year: '2025',
    status: 'all',
    type: 'all'
  });

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
        style={{
          borderColor: actionColor || '#6B7280',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">الأرشيف والبحث</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="text-white font-semibold mb-2 block text-right">البحث في الأرشيف</label>
              <div className="relative">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e?.target?.value)}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 pr-10 text-white text-right"
                  placeholder="ابحث برقم العقد، اسم العميل، أو العقار..."
                  dir="rtl"
                />
                <Icon name="Search" size={20} color="#9CA3AF" className="absolute left-3 top-3.5" />
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4">
              <div>
                <label className="text-white text-sm mb-1 block text-right">السنة</label>
                <select
                  value={archiveFilters?.year}
                  onChange={(e) => setArchiveFilters(prev => ({ ...prev, year: e?.target?.value }))}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-2 text-white text-sm"
                  dir="rtl">
                  <option value="2026">2026</option>
                  <option value="2025">2025</option>
                  <option value="2024">2024</option>
                  <option value="2023">2023</option>
                </select>
              </div>
              <div>
                <label className="text-white text-sm mb-1 block text-right">الحالة</label>
                <select
                  value={archiveFilters?.status}
                  onChange={(e) => setArchiveFilters(prev => ({ ...prev, status: e?.target?.value }))}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-2 text-white text-sm"
                  dir="rtl">
                  <option value="all">الكل</option>
                  <option value="completed">مكتمل</option>
                  <option value="terminated">منتهي</option>
                  <option value="cancelled">ملغي</option>
                </select>
              </div>
              <div>
                <label className="text-white text-sm mb-1 block text-right">النوع</label>
                <select
                  value={archiveFilters?.type}
                  onChange={(e) => setArchiveFilters(prev => ({ ...prev, type: e?.target?.value }))}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-2 text-white text-sm"
                  dir="rtl">
                  <option value="all">الكل</option>
                  <option value="residential">سكني</option>
                  <option value="commercial">تجاري</option>
                </select>
              </div>
            </div>

            <div className="bg-gray-800/50 rounded-lg p-4">
              <h4 className="text-white font-semibold mb-3 text-right">نتائج البحث</h4>
              <div className="space-y-2">
                {[1, 2, 3]?.map((item) => (
                  <div key={item} className="flex items-center justify-between p-3 bg-gray-700/30 rounded-lg hover:bg-gray-700/50 transition-colors cursor-pointer">
                    <div className="text-right flex-1">
                      <p className="text-white font-medium">عقد رقم ARC-2024-{item}23</p>
                      <p className="text-gray-400 text-sm">شقة في عجمان - منتهي</p>
                    </div>
                    <button className="px-3 py-1 bg-gray-600 hover:bg-gray-500 rounded text-white text-sm transition-colors">
                      <Icon name="Download" size={16} color="#FFF" className="inline mr-1" />
                      تحميل
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => console.log('Create backup')}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors">
                <Icon name="HardDrive" size={18} color="#FFF" className="inline ml-2" />
                نسخ احتياطي
              </button>
              <button
                onClick={() => console.log('Export archive')}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-green-600 hover:bg-green-700 transition-colors">
                <Icon name="Download" size={18} color="#FFF" className="inline ml-2" />
                تصدير
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Add this block - getActionDetails function definition
const getActionDetails = (actionId) => {
  const actionDetailsMap = {
    'draft-creation': {
      title: 'إنشاء المسودات',
      description: 'إنشاء وإدارة مسودات العقود الجديدة',
      workflow: [
        { id: 1, step: '1', title: 'جمع المعلومات', desc: 'جمع معلومات العقار والعميل', status: 'completed' },
        { id: 2, step: '2', title: 'صياغة العقد', desc: 'كتابة بنود العقد الأولية', status: 'active' },
        { id: 3, step: '3', title: 'المراجعة الداخلية', desc: 'مراجعة المسودة داخلياً', status: 'pending' }
      ],
      tasks: [
        { id: 1, title: 'مسودات قيد الإنشاء', count: 5, priority: 'high' },
        { id: 2, title: 'مسودات جاهزة للمراجعة', count: 3, priority: 'medium' }
      ],
      options: [
        { id: 1, label: 'إنشاء عقد جديد', icon: 'FilePlus', action: 'create_draft' },
        { id: 2, label: 'استيراد قالب', icon: 'Download', action: 'import_template' }
      ]
    },
    'legal-review': {
      title: 'المراجعة القانونية',
      description: 'مراجعة العقود من الناحية القانونية',
      workflow: [
        { id: 1, step: '1', title: 'فحص الامتثال', desc: 'التحقق من توافق العقد مع القوانين', status: 'completed' },
        { id: 2, step: '2', title: 'مراجعة البنود', desc: 'مراجعة جميع البنود القانونية', status: 'active' },
        { id: 3, step: '3', title: 'الاعتماد القانوني', desc: 'اعتماد العقد قانونياً', status: 'pending' }
      ],
      tasks: [
        { id: 1, title: 'عقود تحتاج مراجعة', count: 2, priority: 'urgent' },
        { id: 2, title: 'عقود قيد المراجعة', count: 4, priority: 'high' }
      ],
      options: [
        { id: 1, label: 'بدء المراجعة', icon: 'Scale', action: 'start_review' },
        { id: 2, label: 'فحص الامتثال', icon: 'CheckCircle', action: 'compliance_check' }
      ]
    },
    'approval': {
      title: 'الموافقة والاعتماد',
      description: 'اعتماد العقود من قبل الإدارة',
      workflow: [
        { id: 1, step: '1', title: 'مراجعة المدير', desc: 'مراجعة مدير القسم', status: 'completed' },
        { id: 2, step: '2', title: 'الموافقة النهائية', desc: 'موافقة الإدارة العليا', status: 'active' }
      ],
      tasks: [
        { id: 1, title: 'بانتظار الموافقة', count: 6, priority: 'high' },
        { id: 2, title: 'تم الاعتماد', count: 12, priority: 'low' }
      ],
      options: [
        { id: 1, label: 'الموافقة', icon: 'ThumbsUp', action: 'approve' },
        { id: 2, label: 'الرفض', icon: 'ThumbsDown', action: 'reject' }
      ]
    },
    'digital-signing': {
      title: 'التوقيع الإلكتروني',
      description: 'إدارة التوقيعات الإلكترونية للعقود',
      workflow: [
        { id: 1, step: '1', title: 'إرسال للتوقيع', desc: 'إرسال العقد للأطراف', status: 'completed' },
        { id: 2, step: '2', title: 'جمع التوقيعات', desc: 'انتظار توقيع جميع الأطراف', status: 'active' },
        { id: 3, step: '3', title: 'التحقق', desc: 'التحقق من التوقيعات', status: 'pending' }
      ],
      tasks: [
        { id: 1, title: 'بانتظار التوقيع', count: 8, priority: 'high' },
        { id: 2, title: 'موقعة جزئياً', count: 3, priority: 'medium' }
      ],
      options: [
        { id: 1, label: 'إرسال للتوقيع', icon: 'Send', action: 'send_for_signature' },
        { id: 2, label: 'التحقق من التوقيع', icon: 'CheckCircle', action: 'verify_signature' }
      ]
    },
    'execution': {
      title: 'التنفيذ والمتابعة',
      description: 'متابعة تنفيذ العقود النشطة',
      workflow: [
        { id: 1, step: '1', title: 'تفعيل العقد', desc: 'تفعيل العقد في النظام', status: 'completed' },
        { id: 2, step: '2', title: 'المتابعة', desc: 'متابعة الدفعات والالتزامات', status: 'active' }
      ],
      tasks: [
        { id: 1, title: 'عقود نشطة', count: 24, priority: 'medium' },
        { id: 2, title: 'دفعات مستحقة', count: 7, priority: 'high' }
      ],
      options: [
        { id: 1, label: 'تفعيل العقد', icon: 'Play', action: 'activate_contract' },
        { id: 2, label: 'جدولة الدفعات', icon: 'Calendar', action: 'schedule_payments' }
      ]
    },
    'renewal': {
      title: 'التجديد والتحديث',
      description: 'إدارة تجديد العقود المنتهية',
      workflow: [
        { id: 1, step: '1', title: 'مراجعة العقد', desc: 'مراجعة شروط التجديد', status: 'completed' },
        { id: 2, step: '2', title: 'التفاوض', desc: 'التفاوض مع العميل', status: 'active' },
        { id: 3, step: '3', title: 'إصدار عقد جديد', desc: 'إصدار عقد التجديد', status: 'pending' }
      ],
      tasks: [
        { id: 1, title: 'عقود قريبة الانتهاء', count: 5, priority: 'urgent' },
        { id: 2, title: 'عقود قيد التجديد', count: 3, priority: 'high' }
      ],
      options: [
        { id: 1, label: 'بدء التجديد', icon: 'RefreshCw', action: 'start_renewal' },
        { id: 2, label: 'التواصل مع العميل', icon: 'Phone', action: 'contact_client' }
      ]
    },
    'termination': {
      title: 'الإنهاء والإلغاء',
      description: 'إنهاء العقود وحساب التسويات',
      workflow: [
        { id: 1, step: '1', title: 'طلب الإنهاء', desc: 'استلام طلب إنهاء العقد', status: 'completed' },
        { id: 2, step: '2', title: 'حساب التسوية', desc: 'حساب المبالغ المستحقة', status: 'active' },
        { id: 3, step: '3', title: 'إنهاء رسمي', desc: 'إنهاء العقد رسمياً', status: 'pending' }
      ],
      tasks: [
        { id: 1, title: 'طلبات إنهاء', count: 2, priority: 'high' },
        { id: 2, title: 'تسويات معلقة', count: 1, priority: 'medium' }
      ],
      options: [
        { id: 1, label: 'إنهاء العقد', icon: 'XCircle', action: 'start_termination' },
        { id: 2, label: 'حساب التسوية', icon: 'Calculator', action: 'calculate_settlement' }
      ]
    },
    'archive': {
      title: 'الأرشفة والتخزين',
      description: 'أرشفة العقود المنتهية والبحث فيها',
      workflow: [
        { id: 1, step: '1', title: 'الأرشفة', desc: 'نقل العقد إلى الأرشيف', status: 'completed' },
        { id: 2, step: '2', title: 'الفهرسة', desc: 'فهرسة العقد للبحث', status: 'completed' }
      ],
      tasks: [
        { id: 1, title: 'عقود مؤرشفة', count: 156, priority: 'low' },
        { id: 2, title: 'عقود تحتاج أرشفة', count: 4, priority: 'medium' }
      ],
      options: [
        { id: 1, label: 'أرشفة عقد', icon: 'Archive', action: 'archive' },
        { id: 2, label: 'البحث في الأرشيف', icon: 'Search', action: 'search_archive' }
      ]
    }
  };

  return actionDetailsMap?.[actionId] || {
    title: 'إجراء غير معروف',
    description: 'لا توجد معلومات متاحة',
    workflow: [],
    tasks: [],
    options: []
  };
};

const NewContractModal = ({ isOpen, onClose, actionColor, contractTypeConfig }) => {
  const [formData, setFormData] = useState({
    // Contract Basic Info
    contractType: '',
    contractNumber: '',
    propertyId: '',
    propertyTitle: '',
    propertyType: '',
    location: '',
    area: '',
    
    // Client Information
    clientName: '',
    clientId: '',
    clientPhone: '',
    clientEmail: '',
    clientNationality: '',
    
    // Contract Terms
    startDate: '',
    endDate: '',
    duration: '',
    rentAmount: '',
    paymentMethod: '',
    paymentFrequency: '',
    deposit: '',
    
    // Legal Terms
    maintenanceResponsibility: '',
    utilitiesResponsibility: '',
    renewalTerms: '',
    terminationNotice: '',
    penaltyClause: '',
    disputeResolution: '',
    
    // Additional Terms
    specialConditions: '',
    insuranceRequired: false,
    petsAllowed: false,
    sublettingAllowed: false,
    
    // Attachments
    attachments: []
  });

  const [currentStep, setCurrentStep] = useState(1);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  if (!isOpen) return null;

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e?.target?.files);
    const newFiles = files?.map(file => ({
      name: file?.name,
      size: `${(file?.size / 1024 / 1024)?.toFixed(2)} ميجابايت`,
      type: file?.type,
      uploadDate: new Date()?.toLocaleDateString('ar-SA')
    }));
    setUploadedFiles(prev => [...prev, ...newFiles]);
  };

  const removeFile = (index) => {
    setUploadedFiles(prev => prev?.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    try {
      // Validate required fields
      if (!formData?.contractType || !formData?.contractNumber || !formData?.propertyTitle) {
        alert('يرجى ملء جميع الحقول المطلوبة');
        return;
      }

      // Get authenticated user
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) {
        alert('يجب تسجيل الدخول أولاً');
        return;
      }

      // Create contract in database with proper UUID
      const { data: newContract, error } = await supabase
        ?.from('contracts')
        ?.insert({
          contract_number: formData?.contractNumber,
          contract_type: formData?.contractType,
          property_title: formData?.propertyTitle,
          property_type: formData?.propertyType,
          location: formData?.location,
          area: formData?.area,
          client_name: formData?.clientName,
          client_phone: formData?.clientPhone,
          client_email: formData?.clientEmail,
          start_date: formData?.startDate,
          end_date: formData?.endDate,
          amount: parseFloat(formData?.rentAmount) || 0,
          deposit: parseFloat(formData?.deposit) || 0,
          payment_method: formData?.paymentMethod,
          payment_frequency: formData?.paymentFrequency,
          special_conditions: formData?.specialConditions,
          status: 'pending',
          created_by: user?.id
        })
        ?.select()
        ?.single();

      if (error) {
        console.error('Error creating contract:', error);
        alert(`فشل في إنشاء العقد: ${error?.message}`);
        return;
      }

      console.log('Contract created successfully:', newContract);
      alert('تم إنشاء العقد بنجاح');
      onClose();
    } catch (error) {
      console.error('Error submitting contract:', error);
      alert(`حدث خطأ: ${error?.message}`);
    }
  };

  const steps = [
    { id: 1, title: 'معلومات العقار', icon: 'Home' },
    { id: 2, title: 'بيانات العميل', icon: 'User' },
    { id: 3, title: 'شروط العقد', icon: 'FileText' },
    { id: 4, title: 'الشروط القانونية', icon: 'Scale' },
    { id: 5, title: 'المرفقات', icon: 'Paperclip' }
  ];

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10000]" onClick={onClose} />
      <div className="fixed z-[10001] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-[90vw] max-w-[700px] max-h-[90vh] overflow-y-auto"
        style={{
          borderColor: actionColor || 'rgba(139, 92, 246, 0.5)',
          boxShadow: `0 25px 80px ${actionColor || '#8B5CF6'}40`,
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
        
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-700/50" style={{
          background: `linear-gradient(135deg, ${actionColor || '#8B5CF6'}15 0%, ${actionColor || '#8B5CF6'}05 100%)`
        }}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="p-3 rounded-xl shadow-lg" style={{ 
                background: `linear-gradient(135deg, ${actionColor || '#8B5CF6'}30 0%, ${actionColor || '#8B5CF6'}40 100%)`,
                boxShadow: `0 4px 15px ${actionColor || '#8B5CF6'}50`
              }}>
                <Icon name="FileSignature" size={28} color={actionColor || '#8B5CF6'} />
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-1" style={{ color: actionColor || '#8B5CF6' }}>
                  إنشاء عقد جديد
                </h3>
                <p className="text-sm text-gray-400">املأ جميع الحقول المطلوبة لإنشاء عقد جديد</p>
              </div>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-700/50 rounded-lg transition-colors">
              <Icon name="X" size={22} color="#9CA3AF" />
            </button>
          </div>
        </div>

        {/* Steps Progress */}
        <div className="px-6 py-4 border-b border-gray-700/50 bg-gray-800/30">
          <div className="flex items-center justify-between">
            {steps?.map((step, index) => (
              <React.Fragment key={step?.id}>
                <div className="flex flex-col items-center gap-2">
                  <div 
                    className={`w-12 h-12 rounded-full flex items-center justify-center font-bold transition-all duration-300 ${
                      currentStep === step?.id ? 'scale-110' : currentStep > step?.id ? 'scale-100' : 'scale-90'
                    }`}
                    style={{
                      backgroundColor: currentStep >= step?.id ? `${actionColor || '#8B5CF6'}30` : 'rgba(75, 85, 99, 0.3)',
                      border: `2px solid ${currentStep >= step?.id ? actionColor || '#8B5CF6' : '#4B5563'}`,
                      color: currentStep >= step?.id ? actionColor || '#8B5CF6' : '#9CA3AF'
                    }}>
                    {currentStep > step?.id ? (
                      <Icon name="CheckCircle" size={20} color={actionColor || '#8B5CF6'} />
                    ) : (
                      <Icon name={step?.icon} size={20} color={currentStep >= step?.id ? actionColor || '#8B5CF6' : '#9CA3AF'} />
                    )}
                  </div>
                  <span className={`text-xs font-medium ${currentStep >= step?.id ? 'text-white' : 'text-gray-500'}`}>
                    {step?.title}
                  </span>
                </div>
                {index < steps?.length - 1 && (
                  <div className="flex-1 h-0.5 mx-2 mb-6" style={{
                    backgroundColor: currentStep > step?.id ? actionColor || '#8B5CF6' : 'rgba(75, 85, 99, 0.5)'
                  }} />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Form Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-280px)] custom-scrollbar">
          {/* Step 1: Property Information */}
          {currentStep === 1 && (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">نوع العقد *</label>
                  <select 
                    value={formData?.contractType}
                    onChange={(e) => handleInputChange('contractType', e?.target?.value)}
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500">
                    <option value="">اختر نوع العقد</option>
                    <option value="rent">عقد إيجار</option>
                    <option value="sale">عقد بيع</option>
                    <option value="lease">عقد تأجير تمويلي</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">رقم العقد *</label>
                  <input 
                    type="text"
                    value={formData?.contractNumber}
                    onChange={(e) => handleInputChange('contractNumber', e?.target?.value)}
                    placeholder="CNT-2026-XXX"
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">عنوان العقار *</label>
                <input 
                  type="text"
                  value={formData?.propertyTitle}
                  onChange={(e) => handleInputChange('propertyTitle', e?.target?.value)}
                  placeholder="مثال: شقة فاخرة في دبي مارينا"
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">نوع العقار *</label>
                  <select 
                    value={formData?.propertyType}
                    onChange={(e) => handleInputChange('propertyType', e?.target?.value)}
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500">
                    <option value="">اختر نوع العقار</option>
                    <option value="apartment">شقة</option>
                    <option value="villa">فيلا</option>
                    <option value="office">مكتب</option>
                    <option value="shop">محل تجاري</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">المساحة (متر مربع) *</label>
                  <input 
                    type="text"
                    value={formData?.area}
                    onChange={(e) => handleInputChange('area', e?.target?.value)}
                    placeholder="150"
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">الموقع *</label>
                <input 
                  type="text"
                  value={formData?.location}
                  onChange={(e) => handleInputChange('location', e?.target?.value)}
                  placeholder="دبي مارينا، دبي"
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
              </div>
            </div>
          )}

          {/* Step 2: Client Information */}
          {currentStep === 2 && (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">اسم العميل *</label>
                <input 
                  type="text"
                  value={formData?.clientName}
                  onChange={(e) => handleInputChange('clientName', e?.target?.value)}
                  placeholder="محمد عبدالله السعيد"
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">رقم الهوية *</label>
                  <input 
                    type="text"
                    value={formData?.clientId}
                    onChange={(e) => handleInputChange('clientId', e?.target?.value)}
                    placeholder="أي رقم هوية وطنية"
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">الجنسية *</label>
                  <input 
                    type="text"
                    value={formData?.clientNationality}
                    onChange={(e) => handleInputChange('clientNationality', e?.target?.value)}
                    placeholder="أي جنسية"
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">رقم الهاتف *</label>
                  <input 
                    type="tel"
                    value={formData?.clientPhone}
                    onChange={(e) => handleInputChange('clientPhone', e?.target?.value)}
                    placeholder="+971 50 123 4567"
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">البريد الإلكتروني *</label>
                  <input 
                    type="email"
                    value={formData?.clientEmail}
                    onChange={(e) => handleInputChange('clientEmail', e?.target?.value)}
                    placeholder="client@email.com"
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
                </div>
              </div>
            </div>
          )}

          {/* Step 3: Contract Terms */}
          {currentStep === 3 && (
            <div className="space-y-4">
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">تاريخ البدء *</label>
                  <input 
                    type="date"
                    value={formData?.startDate}
                    onChange={(e) => handleInputChange('startDate', e?.target?.value)}
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">تاريخ الانتهاء *</label>
                  <input 
                    type="date"
                    value={formData?.endDate}
                    onChange={(e) => handleInputChange('endDate', e?.target?.value)}
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">المدة *</label>
                  <select 
                    value={formData?.duration}
                    onChange={(e) => handleInputChange('duration', e?.target?.value)}
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500">
                    <option value="">اختر المدة</option>
                    <option value="6months">6 أشهر</option>
                    <option value="1year">سنة واحدة</option>
                    <option value="2years">سنتان</option>
                    <option value="3years">3 سنوات</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">قيمة الإيجار (دينار أردني) *</label>
                  <input 
                    type="text"
                    value={formData?.rentAmount}
                    onChange={(e) => handleInputChange('rentAmount', e?.target?.value)}
                    placeholder="250,000"
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">التأمين (دينار أردني) *</label>
                  <input 
                    type="text"
                    value={formData?.deposit}
                    onChange={(e) => handleInputChange('deposit', e?.target?.value)}
                    placeholder="25,000"
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">طريقة الدفع *</label>
                  <select 
                    value={formData?.paymentMethod}
                    onChange={(e) => handleInputChange('paymentMethod', e?.target?.value)}
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500">
                    <option value="">اختر طريقة الدفع</option>
                    <option value="cheques">شيكات</option>
                    <option value="bank_transfer">تحويل بنكي</option>
                    <option value="cash">نقداً</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">عدد الدفعات *</label>
                  <select 
                    value={formData?.paymentFrequency}
                    onChange={(e) => handleInputChange('paymentFrequency', e?.target?.value)}
                    className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500">
                    <option value="">اختر عدد الدفعات</option>
                    <option value="1">دفعة واحدة</option>
                    <option value="2">دفعتان</option>
                    <option value="4">4 دفعات</option>
                    <option value="12">12 دفعة</option>
                  </select>
                </div>
              </div>
            </div>
          )}

          {/* Step 4: Legal Terms */}
          {currentStep === 4 && (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">مسؤولية الصيانة *</label>
                <textarea 
                  value={formData?.maintenanceResponsibility}
                  onChange={(e) => handleInputChange('maintenanceResponsibility', e?.target?.value)}
                  placeholder="حدد مسؤوليات الصيانة للمالك والمستأجر"
                  rows={3}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">مسؤولية المرافق *</label>
                <textarea 
                  value={formData?.utilitiesResponsibility}
                  onChange={(e) => handleInputChange('utilitiesResponsibility', e?.target?.value)}
                  placeholder="حدد المسؤول عن فواتير الكهرباء والماء والغاز"
                  rows={2}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">شروط التجديد *</label>
                <textarea 
                  value={formData?.renewalTerms}
                  onChange={(e) => handleInputChange('renewalTerms', e?.target?.value)}
                  placeholder="حدد شروط تجديد العقد ونسبة الزيادة المسموحة"
                  rows={2}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">مدة الإشعار بالإنهاء *</label>
                <input 
                  type="text"
                  value={formData?.terminationNotice}
                  onChange={(e) => handleInputChange('terminationNotice', e?.target?.value)}
                  placeholder="مثال: 60 يوماً قبل انتهاء العقد"
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">شرط الغرامة *</label>
                <textarea 
                  value={formData?.penaltyClause}
                  onChange={(e) => handleInputChange('penaltyClause', e?.target?.value)}
                  placeholder="حدد الغرامات في حالة الإخلال بشروط العقد"
                  rows={2}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">آلية حل النزاعات *</label>
                <textarea 
                  value={formData?.disputeResolution}
                  onChange={(e) => handleInputChange('disputeResolution', e?.target?.value)}
                  placeholder="حدد الإجراءات القانونية لحل النزاعات"
                  rows={2}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">شروط خاصة</label>
                <textarea 
                  value={formData?.specialConditions}
                  onChange={(e) => handleInputChange('specialConditions', e?.target?.value)}
                  placeholder="أي شروط إضافية خاصة بهذا العقد"
                  rows={3}
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-purple-500" />
              </div>
              <div className="space-y-3">
                <label className="flex items-center gap-3 cursor-pointer">
                  <input 
                    type="checkbox"
                    checked={formData?.insuranceRequired}
                    onChange={(e) => handleInputChange('insuranceRequired', e?.target?.checked)}
                    className="w-5 h-5 rounded border-gray-700 bg-gray-800 text-purple-600 focus:ring-purple-500" />
                  <span className="text-white">يتطلب تأمين على العقار</span>
                </label>
                <label className="flex items-center gap-3 cursor-pointer">
                  <input 
                    type="checkbox"
                    checked={formData?.petsAllowed}
                    onChange={(e) => handleInputChange('petsAllowed', e?.target?.checked)}
                    className="w-5 h-5 rounded border-gray-700 bg-gray-800 text-purple-600 focus:ring-purple-500" />
                  <span className="text-white">يسمح بتربية الحيوانات الأليفة</span>
                </label>
                <label className="flex items-center gap-3 cursor-pointer">
                  <input 
                    type="checkbox"
                    checked={formData?.sublettingAllowed}
                    onChange={(e) => handleInputChange('sublettingAllowed', e?.target?.checked)}
                    className="w-5 h-5 rounded border-gray-700 bg-gray-800 text-purple-600 focus:ring-purple-500" />
                  <span className="text-white">يسمح بالتأجير من الباطن</span>
                </label>
              </div>
            </div>
          )}

          {/* Step 5: Attachments */}
          {currentStep === 5 && (
            <div className="space-y-4">
              <div className="bg-gradient-to-br from-gray-800/80 to-gray-800/40 rounded-xl p-6 border border-gray-700/50">
                <div className="flex items-center gap-3 mb-4">
                  <Icon name="Upload" size={20} color={actionColor || '#8B5CF6'} />
                  <h4 className="text-lg font-semibold text-white">رفع المستندات المطلوبة</h4>
                </div>
                <div className="border-2 border-dashed border-gray-600 rounded-lg p-8 text-center hover:border-purple-500 transition-colors cursor-pointer"
                  onClick={() => document.getElementById('file-upload')?.click()}>
                  <Icon name="FileUp" size={48} color="#9CA3AF" className="mx-auto mb-3" />
                  <p className="text-white font-medium mb-1">اضغط لرفع الملفات</p>
                  <p className="text-sm text-gray-400">أو اسحب الملفات وأفلتها هنا</p>
                  <p className="text-xs text-gray-500 mt-2">PDF, JPG, PNG (حتى 10 ميجابايت)</p>
                  <input 
                    id="file-upload"
                    type="file" 
                    multiple 
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={handleFileUpload}
                    className="hidden" />
                </div>
              </div>

              {uploadedFiles?.length > 0 && (
                <div className="bg-gradient-to-br from-gray-800/80 to-gray-800/40 rounded-xl p-4 border border-gray-700/50">
                  <h5 className="text-white font-semibold mb-3 flex items-center gap-2">
                    <Icon name="Paperclip" size={18} color={actionColor || '#8B5CF6'} />
                    الملفات المرفقة ({uploadedFiles?.length})
                  </h5>
                  <div className="space-y-2">
                    {uploadedFiles?.map((file, index) => (
                      <div key={index} className="flex items-center justify-between bg-gray-900/50 rounded-lg p-3">
                        <div className="flex items-center gap-3">
                          <div className="p-2 rounded-lg" style={{ backgroundColor: `${actionColor || '#8B5CF6'}20` }}>
                            <Icon name="FileText" size={20} color={actionColor || '#8B5CF6'} />
                          </div>
                          <div>
                            <p className="text-xs text-white truncate">{file?.name}</p>
                            <p className="text-xs text-gray-500">{file?.size} • {file?.uploadDate}</p>
                          </div>
                        </div>
                        <button 
                          onClick={() => removeFile(index)}
                          className="p-2 hover:bg-red-500/20 rounded-lg transition-colors">
                          <Icon name="Trash2" size={18} color="#EF4444" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4">
                <div className="flex gap-3">
                  <Icon name="Info" size={20} color="#3B82F6" className="flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-blue-400 font-medium mb-1">المستندات المطلوبة:</p>
                    <ul className="text-sm text-blue-300 space-y-1">
                      <li>• نسخة من الهوية الوطنية أو جواز السفر</li>
                      <li>• إثبات الدخل (كشف حساب بنكي أو شهادة راتب)</li>
                      <li>• شيكات الإيجار (حسب عدد الدفعات المتفق عليها)</li>
                      <li>• صور العقار (اختياري)</li>
                      <li>• أي مستندات إضافية متفق عليها</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-700/50 bg-gray-800/30">
          <div className="flex items-center justify-between">
            <button
              onClick={() => currentStep > 1 ? setCurrentStep(currentStep - 1) : onClose()}
              className="px-5 py-2.5 rounded-lg font-medium text-gray-300 hover:text-white hover:bg-gray-700/50 transition-all flex items-center gap-2">
              <Icon name="ChevronRight" size={18} color="#9CA3AF" />
              {currentStep > 1 ? 'السابق' : 'إلغاء'}
            </button>
            <div className="flex items-center gap-3">
              <button
                onClick={() => {
                  console.log('Saved as draft:', formData);
                  onClose();
                }}
                className="px-5 py-2.5 rounded-lg font-medium text-gray-300 hover:text-white hover:bg-gray-700/50 transition-all flex items-center gap-2">
                <Icon name="Save" size={18} color="#9CA3AF" />
                حفظ كمسودة
              </button>
              {currentStep < 5 ? (
                <button
                  onClick={() => setCurrentStep(currentStep + 1)}
                  className="px-6 py-2.5 rounded-lg font-semibold text-white transition-all hover:scale-105 active:scale-95 shadow-lg flex items-center gap-2"
                  style={{
                    background: `linear-gradient(135deg, ${actionColor || '#8B5CF6'}80 0%, ${actionColor || '#8B5CF6'}90 100%)`,
                    boxShadow: `0 4px 15px ${actionColor || '#8B5CF6'}40`
                  }}>
                  التالي
                  <Icon name="ChevronLeft" size={18} color="#FFFFFF" />
                </button>
              ) : (
                <button
                  onClick={handleSubmit}
                  className="px-6 py-2.5 rounded-lg font-semibold text-white transition-all hover:scale-105 active:scale-95 shadow-lg flex items-center gap-2"
                  style={{
                    background: `linear-gradient(135deg, ${actionColor || '#8B5CF6'}80 0%, ${actionColor || '#8B5CF6'}90 100%)`,
                    boxShadow: `0 4px 15px ${actionColor || '#8B5CF6'}40`
                  }}>
                  <Icon name="Check" size={18} color="#FFFFFF" />
                  إرسال للموافقة
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const ActionBoxPopup = ({ action, onClose, position }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [showNewContractModal, setShowNewContractModal] = useState(false);
  const [showLegalReviewModal, setShowLegalReviewModal] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showDigitalSigningModal, setShowDigitalSigningModal] = useState(false);
  const [showExecutionModal, setShowExecutionModal] = useState(false);
  const [showRenewalModal, setShowRenewalModal] = useState(false);
  const [showTerminationModal, setShowTerminationModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [selectedContract, setSelectedContract] = useState(null);
  
  if (!action) return null;

  const [reviewNotes, setReviewNotes] = useState('');
  const [complianceChecks, setComplianceChecks] = useState({
    propertyLaws: false,
    tenancyRules: false,
    financialTerms: false,
    disputeResolution: false
  });

  const [approvalNotes, setApprovalNotes] = useState('');
  const [approvalLevel, setApprovalLevel] = useState('manager');

  const [signatories, setSignatories] = useState([
    { name: 'المالك', email: 'owner@example.com', signed: false },
    { name: 'المستأجر', email: 'tenant@example.com', signed: false },
    { name: 'الشاهد', email: 'witness@example.com', signed: false }
  ]);

  const [paymentSchedule, setPaymentSchedule] = useState([
    { date: '2026-02-01', amount: '30,000', status: 'pending' },
    { date: '2026-05-01', amount: '30,000', status: 'pending' },
    { date: '2026-08-01', amount: '30,000', status: 'pending' },
    { date: '2026-11-01', amount: '30,000', status: 'pending' }
  ]);

  const [renewalTerms, setRenewalTerms] = useState({
    newRent: '',
    duration: '12',
    priceIncrease: '',
    startDate: ''
  });

  const [terminationData, setTerminationData] = useState({
    reason: '',
    terminationDate: '',
    penalty: '',
    refundAmount: ''
  });

  const [searchQuery, setSearchQuery] = useState('');
  const [archiveFilters, setArchiveFilters] = useState({
    year: '2025',
    status: 'all',
    type: 'all'
  });

  const [formData, setFormData] = useState({
    // Contract Basic Info
    contractType: '',
    contractNumber: '',
    propertyId: '',
    propertyTitle: '',
    propertyType: '',
    location: '',
    area: '',
    
    // Client Information
    clientName: '',
    clientId: '',
    clientPhone: '',
    clientEmail: '',
    clientNationality: '',
    
    // Contract Terms
    startDate: '',
    endDate: '',
    duration: '',
    rentAmount: '',
    paymentMethod: '',
    paymentFrequency: '',
    deposit: '',
    
    // Legal Terms
    maintenanceResponsibility: '',
    utilitiesResponsibility: '',
    renewalTerms: '',
    terminationNotice: '',
    penaltyClause: '',
    disputeResolution: '',
    
    // Additional Terms
    specialConditions: '',
    insuranceRequired: false,
    petsAllowed: false,
    sublettingAllowed: false,
    
    // Attachments
    attachments: []
  });

  const [currentStep, setCurrentStep] = useState(1);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const actionDetails = getActionDetails(action?.id);

  // Mock contract data for listings
  const getContractListings = (actionId) => {
    const draftContracts = [
      {
        id: 'DRAFT-2026-001',
        title: 'شقة فاخرة في دبي مارينا',
        client: 'محمد عبدالله السعيد',
        value: '250,000 دينار أردني/سنوياً',
        status: 'draft',
        date: '08/01/2026',
        progress: 65,
        attachments: [
          { name: 'مسودة العقد.pdf', size: '1.2 ميجابايت', icon: 'FileText' },
          { name: 'معلومات العقار.pdf', size: '0.8 ميجابايت', icon: 'FileText' }
        ]
      },
      {
        id: 'DRAFT-2026-002',
        title: 'فيلا في جميرا',
        client: 'سارة أحمد الزعابي',
        value: '450,000 دينار أردني/سنوياً',
        status: 'draft',
        date: '07/01/2026',
        progress: 40,
        attachments: [
          { name: 'بيانات أولية.pdf', size: '0.5 ميجابايت', icon: 'FileText' }
        ]
      }
    ];

    const legalReviewContracts = [
      {
        id: 'LR-2026-001',
        title: 'مكتب تجاري في الخليج التجاري',
        client: 'شركة الأعمال المتقدمة',
        value: '180,000 دينار أردني/سنوياً',
        status: 'legal_review',
        date: '06/01/2026',
        reviewer: 'المستشار القانوني أحمد',
        attachments: [
          { name: 'العقد الكامل.pdf', size: '3.2 ميجابايت', icon: 'FileText' },
          { name: 'ملاحظات قانونية.pdf', size: '0.9 ميجابايت', icon: 'FileText' }
        ]
      }
    ];

    const approvalContracts = [
      {
        id: 'APR-2026-001',
        title: 'شقة في الخليج التجاري',
        client: 'خالد محمود',
        value: '120,000 دينار أردني/سنوياً',
        status: 'pending_approval',
        date: '05/01/2026',
        approver: 'مدير العقود',
        attachments: [
          { name: 'العقد المعتمد قانونياً.pdf', size: '3.5 ميجابايت', icon: 'FileCheck' }
        ]
      }
    ];

    const signingContracts = [
      {
        id: 'SIGN-2026-001',
        title: 'محل تجاري في ديرة',
        client: 'علي حسن التميمي',
        value: '95,000 دينار أردني/سنوياً',
        status: 'awaiting_signature',
        date: '04/01/2026',
        signedBy: 'المالك',
        pendingFrom: 'المستأجر',
        attachments: [
          { name: 'العقد النهائي.pdf', size: '4.1 ميجابايت', icon: 'FileSignature' }
        ]
      }
    ];

    const executionContracts = [
      {
        id: 'EXE-2025-089',
        title: 'فيلا في البرشاء',
        client: 'فاطمة سالم',
        value: '320,000 دينار أردني/سنوياً',
        status: 'active',
        date: '15/12/2025',
        nextPayment: '15/02/2026',
        attachments: [
          { name: 'العقد الموقع.pdf', size: '4.5 ميجابايت', icon: 'FileCheck' },
          { name: 'جدول الدفعات.pdf', size: '0.6 ميجابايت', icon: 'FileText' }
        ]
      }
    ];

    const renewalContracts = [
      {
        id: 'REN-2025-045',
        title: 'شقة في الشارقة',
        client: 'عمر يوسف',
        value: '65,000 دينار أردني/سنوياً',
        status: 'renewal_pending',
        date: '10/01/2025',
        expiryDate: '10/02/2026',
        attachments: [
          { name: 'العقد الحالي.pdf', size: '3.8 ميجابايت', icon: 'FileText' },
          { name: 'عرض التجديد.pdf', size: '1.2 ميجابايت', icon: 'RefreshCw' }
        ]
      }
    ];

    const terminationContracts = [
      {
        id: 'TERM-2026-001',
        title: 'مكتب في دبي',
        client: 'شركة التقنية الحديثة',
        value: '140,000 دينار أردني/سنوياً',
        status: 'termination_requested',
        date: '03/01/2026',
        reason: 'انتقال الشركة لمقر أكبر',
        attachments: [
          { name: 'طلب الإنهاء.pdf', size: '1.1 ميجابايت', icon: 'XCircle' },
          { name: 'حساب التسوية.pdf', size: '0.7 ميجابايت', icon: 'Calculator' }
        ]
      }
    ];

    const archiveContracts = [
      {
        id: 'ARC-2024-234',
        title: 'شقة في عجمان',
        client: 'ليلى محمد',
        value: '55,000 دينار أردني/سنوياً',
        status: 'archived',
        date: '15/03/2024',
        endDate: '15/03/2025',
        attachments: [
          { name: 'العقد الكامل.pdf', size: '5.2 ميجابايت', icon: 'Archive' },
          { name: 'وثيقة الإنهاء.pdf', size: '1.5 ميجابايت', icon: 'FileCheck' }
        ]
      }
    ];

    switch(actionId) {
      case 'draft-creation':
        return draftContracts;
      case 'legal-review':
        return legalReviewContracts;
      case 'approval':
        return approvalContracts;
      case 'digital-signing':
        return signingContracts;
      case 'execution':
        return executionContracts;
      case 'renewal':
        return renewalContracts;
      case 'termination':
        return terminationContracts;
      case 'archive':
        return archiveContracts;
      default:
        return draftContracts;
    }
  };

  const contractListings = getContractListings(action?.id);

  const getPriorityColor = (priority) => {
    const colors = {
      urgent: '#EF4444',
      high: '#F59E0B',
      medium: '#3B82F6',
      low: '#10B981'
    };
    return colors?.[priority] || '#6B7280';
  };

  const getStatusIcon = (status) => {
    const icons = {
      completed: 'CheckCircle',
      active: 'PlayCircle',
      pending: 'Circle'
    };
    return icons?.[status] || 'Circle';
  };

  const getStatusColor = (status) => {
    const colors = {
      completed: '#10B981',
      active: '#3B82F6',
      pending: '#6B7280'
    };
    return colors?.[status] || '#6B7280';
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9998]"
        onClick={onClose}
      />
      {/* Popup */}
      <div 
        className="fixed z-[9999] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 min-w-[500px] max-w-[600px] max-h-[85vh] overflow-hidden animate-in fade-in zoom-in duration-200"
        style={{
          borderColor: action?.color || 'rgba(59, 130, 246, 0.5)',
          boxShadow: `0 25px 80px ${action?.color || '#3B82F6'}40, 0 0 0 1px ${action?.color || '#3B82F6'}20`,
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-700/50" style={{
          background: `linear-gradient(135deg, ${action?.color || '#8B5CF6'}15 0%, ${action?.color || '#8B5CF6'}05 100%)`
        }}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="p-3 rounded-xl shadow-lg" style={{ 
                background: `linear-gradient(135deg, ${action?.color || '#8B5CF6'}30 0%, ${action?.color || '#8B5CF6'}40 100%)`,
                boxShadow: `0 4px 12px ${action?.color || '#3B82F6'}50`
              }}>
                <Icon name={action?.icon} size={28} color={action?.color || '#8B5CF6'} />
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-1" style={{ color: action?.color || '#8B5CF6' }}>
                  {actionDetails?.title || action?.title || action?.label}
                </h3>
                <p className="text-sm text-gray-400">{actionDetails?.description}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-700/50 rounded-lg transition-colors duration-200"
            >
              <Icon name="X" size={22} color="#9CA3AF" />
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex border-b border-gray-700/50 bg-gray-800/30">
          {[
            { id: 'overview', label: 'نظرة عامة', icon: 'LayoutDashboard' },
            { id: 'contracts', label: 'العقود', icon: 'FileText' },
            { id: 'workflow', label: 'سير العمل', icon: 'GitBranch' },
            { id: 'tasks', label: 'المهام', icon: 'CheckSquare' },
            { id: 'options', label: 'الخيارات', icon: 'Settings' }
          ]?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => setActiveTab(tab?.id)}
              className={`flex-1 px-3 py-3 text-xs font-medium transition-all duration-200 flex items-center justify-center gap-2 ${
                activeTab === tab?.id
                  ? 'border-b-2 text-white' :'text-gray-400 hover:text-gray-300 hover:bg-gray-700/30'
              }`}
              style={{
                borderColor: activeTab === tab?.id ? action?.color : 'transparent'
              }}
            >
              <Icon name={tab?.icon} size={14} color={activeTab === tab?.id ? action?.color : '#9CA3AF'} />
              {tab?.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(85vh-200px)] custom-scrollbar">
          {/* Overview Tab */}
          {activeTab === 'overview' && (
            <div className="space-y-4">
              <div className="bg-gradient-to-br from-gray-800/80 to-gray-800/40 rounded-xl p-5 border border-gray-700/50">
                <div className="flex items-center gap-2 mb-3">
                  <Icon name="Info" size={18} color={action?.color} />
                  <h4 className="text-lg font-semibold text-white">معلومات الإجراء</h4>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs text-gray-400 mb-1">معرف الإجراء</p>
                    <p className="text-white font-medium">{action?.id}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-1">الأيقونة</p>
                    <p className="text-white font-medium">{action?.icon}</p>
                  </div>
                  <div className="col-span-2">
                    <p className="text-xs text-gray-400 mb-1">اللون المميز</p>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-lg shadow-md border-2" style={{ backgroundColor: action?.color || '#3B82F6', borderColor: action?.borderColor || 'rgba(59, 130, 246, 0.5)' }} />
                      <span className="text-white text-sm font-mono">{action?.color || '#3B82F6'}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-800/80 to-gray-800/40 rounded-xl p-4 border border-gray-700/50">
                <div className="flex items-center gap-2 mb-3">
                  <Icon name="BarChart3" size={18} color={action?.color} />
                  <h4 className="text-lg font-semibold text-white">إحصائيات سريعة</h4>
                </div>
                <div className="grid grid-cols-3 gap-3">
                  <div className="bg-gray-900/50 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold" style={{ color: action?.color }}>
                      {actionDetails?.tasks?.reduce((sum, task) => sum + task?.count, 0) || 0}
                    </p>
                    <p className="text-xs text-gray-400 mt-1">إجمالي المهام</p>
                  </div>
                  <div className="bg-gray-900/50 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold" style={{ color: action?.color }}>
                      {actionDetails?.workflow?.filter(w => w?.status === 'completed')?.length || 0}
                    </p>
                    <p className="text-xs text-gray-400 mt-1">مراحل مكتملة</p>
                  </div>
                  <div className="bg-gray-900/50 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold" style={{ color: action?.color }}>
                      {actionDetails?.options?.length || 0}
                    </p>
                    <p className="text-xs text-gray-400 mt-1">خيارات متاحة</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Contracts Tab */}
          {activeTab === 'contracts' && (
            <div className="space-y-3">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                  <Icon name="FileText" size={18} color={action?.color} />
                  <h4 className="text-lg font-semibold text-white">قائمة العقود ({contractListings?.length})</h4>
                </div>
                {action?.id === 'draft-creation' && (
                  <button
                    onClick={() => setShowNewContractModal(true)}
                    className="px-4 py-2 rounded-lg font-medium text-white transition-all hover:scale-105 active:scale-95 shadow-lg flex items-center gap-2"
                    style={{
                      background: action?.bgGradient || 'linear-gradient(135deg, rgba(139, 92, 246, 0.8) 0%, rgba(167, 139, 250, 0.9) 100%)'
                    }}>
                    <Icon name="Plus" size={16} color="#FFFFFF" />
                    عقد جديد
                  </button>
                )}
              </div>
              
              {contractListings?.length === 0 ? (
                <div className="bg-gradient-to-br from-gray-800/80 to-gray-800/40 rounded-xl p-8 border border-gray-700/50 text-center">
                  <Icon name="FileX" size={48} color="#6B7280" className="mx-auto mb-3" />
                  <p className="text-gray-400">لا توجد عقود في هذه الفئة</p>
                </div>
              ) : (
                contractListings?.map((contract) => (
                  <div 
                    key={contract?.id}
                    className="bg-gradient-to-br from-gray-800/80 to-gray-800/40 rounded-xl p-4 border border-gray-700/50 hover:border-gray-600/50 transition-all duration-200">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                          <h5 className="text-white font-semibold">{contract?.title}</h5>
                          <span className="text-xs text-gray-400">#{contract?.id}</span>
                        </div>
                        <div className="flex items-center gap-4 text-sm text-gray-400">
                          <span className="flex items-center gap-1">
                            <Icon name="User" size={14} color="#9CA3AF" />
                            {contract?.client}
                          </span>
                          <span className="flex items-center gap-1">
                            <Icon name="Calendar" size={14} color="#9CA3AF" />
                            {contract?.date}
                          </span>
                        </div>
                        <p className="text-sm font-medium mt-1" style={{ color: action?.color }}>
                          {contract?.value}
                        </p>
                        {contract?.progress && (
                          <div className="mt-2">
                            <div className="flex items-center justify-between text-xs text-gray-400 mb-1">
                              <span>التقدم</span>
                              <span>{contract?.progress}%</span>
                            </div>
                            <div className="w-full bg-gray-700 rounded-full h-1.5">
                              <div 
                                className="h-1.5 rounded-full transition-all"
                                style={{ 
                                  width: `${contract?.progress}%`,
                                  backgroundColor: action?.color 
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {contract?.reviewer && (
                          <p className="text-xs text-gray-400 mt-1 flex items-center gap-1">
                            <Icon name="UserCheck" size={12} color="#9CA3AF" />
                            المراجع: {contract?.reviewer}
                          </p>
                        )}
                        {contract?.approver && (
                          <p className="text-xs text-gray-400 mt-1 flex items-center gap-1">
                            <Icon name="Shield" size={12} color="#9CA3AF" />
                            المعتمد: {contract?.approver}
                          </p>
                        )}
                        {contract?.signedBy && (
                          <p className="text-xs text-green-400 mt-1 flex items-center gap-1">
                            <Icon name="CheckCircle" size={12} color="#10B981" />
                            وقع من: {contract?.signedBy}
                          </p>
                        )}
                        {contract?.pendingFrom && (
                          <p className="text-xs text-yellow-400 mt-1 flex items-center gap-1">
                            <Icon name="Clock" size={12} color="#F59E0B" />
                            بانتظار: {contract?.pendingFrom}
                          </p>
                        )}
                        {contract?.nextPayment && (
                          <p className="text-xs text-blue-400 mt-1 flex items-center gap-1">
                            <Icon name="DollarSign" size={12} color="#3B82F6" />
                            الدفعة القادمة: {contract?.nextPayment}
                          </p>
                        )}
                        {contract?.expiryDate && (
                          <p className="text-xs text-orange-400 mt-1 flex items-center gap-1">
                            <Icon name="AlertCircle" size={12} color="#F59E0B" />
                            ينتهي في: {contract?.expiryDate}
                          </p>
                        )}
                        {contract?.reason && (
                          <p className="text-xs text-red-400 mt-1 flex items-center gap-1">
                            <Icon name="AlertTriangle" size={12} color="#EF4444" />
                            {contract?.reason}
                          </p>
                        )}
                        {contract?.endDate && (
                          <p className="text-xs text-gray-500 mt-1 flex items-center gap-1">
                            <Icon name="Calendar" size={12} color="#6B7280" />
                            انتهي في: {contract?.endDate}
                          </p>
                        )}
                      </div>
                    </div>
                    
                    {/* Attachments */}
                    <div className="mt-3 pt-3 border-t border-gray-700/50">
                      <div className="flex items-center gap-2 mb-2">
                        <Icon name="Paperclip" size={14} color={action?.color} />
                        <span className="text-xs font-medium text-gray-300">المرفقات ({contract?.attachments?.length})</span>
                      </div>
                      <div className="grid grid-cols-2 gap-2">
                        {contract?.attachments?.map((file, idx) => (
                          <div 
                            key={idx}
                            className="flex items-center gap-2 bg-gray-900/50 rounded-lg p-2 hover:bg-gray-900/70 transition-colors cursor-pointer">
                            <div className="p-1.5 rounded" style={{ backgroundColor: `${action?.color}20` }}>
                              <Icon name={file?.icon} size={14} color={action?.color} />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-xs text-white truncate">{file?.name}</p>
                              <p className="text-xs text-gray-500">{file?.size}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Action Buttons for Each Contract */}
                    <div className="mt-3 pt-3 border-t border-gray-700/50">
                      <div className="flex gap-2">
                        {action?.id === 'draft-creation' && (
                          <>
                            <button
                              onClick={() => {
                                setSelectedContract(contract);
                                console.log('Continue editing draft:', contract?.id);
                              }}
                              className="flex-1 px-3 py-2 rounded-lg text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 transition-colors flex items-center justify-center gap-1">
                              <Icon name="Edit" size={14} color="#FFF" />
                              متابعة التحرير
                            </button>
                            <button
                              onClick={() => {
                                console.log('Send to legal review:', contract?.id);
                                alert('تم إرسال العقد للمراجعة القانونية');
                              }}
                              className="flex-1 px-3 py-2 rounded-lg text-sm font-medium text-white bg-green-600 hover:bg-green-700 transition-colors flex items-center justify-center gap-1">
                              <Icon name="Send" size={14} color="#FFF" />
                              إرسال للمراجعة
                            </button>
                          </>
                        )}
                        {action?.id === 'legal-review' && (
                          <>
                            <button
                              onClick={() => {
                                setSelectedContract(contract);
                                setShowLegalReviewModal(true);
                              }}
                              className="flex-1 px-3 py-2 rounded-lg text-sm font-medium text-white bg-pink-600 hover:bg-pink-700 transition-colors flex items-center justify-center gap-1">
                              <Icon name="Scale" size={14} color="#FFF" />
                              بدء المراجعة
                            </button>
                            <button
                              onClick={() => {
                                console.log('View contract details:', contract?.id);
                              }}
                              className="px-3 py-2 rounded-lg text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 transition-colors">
                              <Icon name="Eye" size={14} color="#FFF" />
                            </button>
                          </>
                        )}
                        {action?.id === 'approval' && (
                          <>
                            <button
                              onClick={() => {
                                setSelectedContract(contract);
                                setShowApprovalModal(true);
                              }}
                              className="flex-1 px-3 py-2 rounded-lg text-sm font-medium text-white bg-green-600 hover:bg-green-700 transition-colors flex items-center justify-center gap-1">
                              <Icon name="ThumbsUp" size={14} color="#FFF" />
                              الموافقة
                            </button>
                            <button
                              onClick={() => {
                                if (confirm('هل أنت متأكد من رفض هذا العقد؟')) {
                                  console.log('Rejected:', contract?.id);
                                  alert('تم رفض العقد');
                                }
                              }}
                              className="flex-1 px-3 py-2 rounded-lg text-sm font-medium text-white bg-red-600 hover:bg-red-700 transition-colors flex items-center justify-center gap-1">
                              <Icon name="ThumbsDown" size={14} color="#FFF" />
                              الرفض
                            </button>
                          </>
                        )}
                        {action?.id === 'digital-signing' && (
                          <>
                            <button
                              onClick={() => {
                                setSelectedContract(contract);
                                setShowDigitalSigningModal(true);
                              }}
                              className="flex-1 px-3 py-2 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors flex items-center justify-center gap-1">
                              <Icon name="PenTool" size={14} color="#FFF" />
                              إرسال للتوقيع
                            </button>
                            <button
                              onClick={() => {
                                console.log('Download contract:', contract?.id);
                              }}
                              className="px-3 py-2 rounded-lg text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 transition-colors">
                              <Icon name="Download" size={14} color="#FFF" />
                            </button>
                          </>
                        )}
                        {action?.id === 'execution' && (
                          <>
                            <button
                              onClick={() => {
                                setSelectedContract(contract);
                                setShowExecutionModal(true);
                              }}
                              className="flex-1 px-3 py-2 rounded-lg text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 transition-colors flex items-center justify-center gap-1">
                              <Icon name="Play" size={14} color="#FFF" />
                              إدارة الدفعات
                            </button>
                            <button
                              onClick={() => {
                                console.log('Send payment reminder:', contract?.id);
                                alert('تم إرسال تذكير بالدفعة للعميل');
                              }}
                              className="px-3 py-2 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors">
                              <Icon name="Bell" size={14} color="#FFF" />
                            </button>
                          </>
                        )}
                        {action?.id === 'renewal' && (
                          <>
                            <button
                              onClick={() => {
                                setSelectedContract(contract);
                                setShowRenewalModal(true);
                              }}
                              className="flex-1 px-3 py-2 rounded-lg text-sm font-medium text-white bg-cyan-600 hover:bg-cyan-700 transition-colors flex items-center justify-center gap-1">
                              <Icon name="RefreshCw" size={14} color="#FFF" />
                              بدء التجديد
                            </button>
                            <button
                              onClick={() => {
                                console.log('Contact client:', contract?.id);
                                alert('جاري الاتصال بالعميل...');
                              }}
                              className="px-3 py-2 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors">
                              <Icon name="Phone" size={14} color="#FFF" />
                            </button>
                          </>
                        )}
                        {action?.id === 'termination' && (
                          <>
                            <button
                              onClick={() => {
                                setSelectedContract(contract);
                                setShowTerminationModal(true);
                              }}
                              className="flex-1 px-3 py-2 rounded-lg text-sm font-medium text-white bg-red-600 hover:bg-red-700 transition-colors flex items-center justify-center gap-1">
                              <Icon name="XCircle" size={14} color="#FFF" />
                              إنهاء العقد
                            </button>
                            <button
                              onClick={() => {
                                console.log('Calculate settlement:', contract?.id);
                                alert('حساب التسوية: 5,000 دينار أردني');
                              }}
                              className="px-3 py-2 rounded-lg text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 transition-colors">
                              <Icon name="Calculator" size={14} color="#FFF" />
                            </button>
                          </>
                        )}
                        {action?.id === 'archive' && (
                          <>
                            <button
                              onClick={() => {
                                console.log('Download archived contract:', contract?.id);
                              }}
                              className="flex-1 px-3 py-2 rounded-lg text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 transition-colors flex items-center justify-center gap-1">
                              <Icon name="Download" size={14} color="#FFF" />
                              تحميل
                            </button>
                            <button
                              onClick={() => {
                                console.log('View archive details:', contract?.id);
                              }}
                              className="px-3 py-2 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors">
                              <Icon name="Eye" size={14} color="#FFF" />
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}

          {/* Workflow Tab */}
          {activeTab === 'workflow' && (
            <div className="space-y-3">
              <div className="flex items-center gap-2 mb-4">
                <Icon name="GitBranch" size={18} color={action?.color} />
                <h4 className="text-lg font-semibold text-white">مراحل سير العمل</h4>
              </div>
              {actionDetails?.workflow?.map((step, index) => (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-gray-800/80 to-gray-800/40 rounded-xl p-4 border border-gray-700/50 hover:border-gray-600/50 transition-all duration-200"
                >
                  <div className="flex items-start gap-4">
                    <div 
                      className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm shadow-lg"
                      style={{
                        backgroundColor: `${getStatusColor(step?.status)}20`,
                        color: getStatusColor(step?.status),
                        border: `2px solid ${getStatusColor(step?.status)}50`
                      }}
                    >
                      {currentStep > step?.id ? (
                        <Icon name="CheckCircle" size={18} color={getStatusColor(step?.status)} />
                      ) : (
                        step?.step
                      )}
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h5 className="text-white font-semibold">{step?.title}</h5>
                        <span 
                          className="px-2 py-0.5 rounded-full text-xs font-medium"
                          style={{
                            backgroundColor: `${getStatusColor(step?.status)}20`,
                            color: getStatusColor(step?.status)
                          }}
                        >
                          {step?.status === 'completed' ? 'مكتمل' : step?.status === 'active' ? 'نشط' : 'معلق'}
                        </span>
                      </div>
                      <p className="text-sm text-gray-400">{step?.desc}</p>
                    </div>
                  </div>
                  {index < actionDetails?.workflow?.length - 1 && (
                    <div 
                      className="w-0.5 h-6 mr-5 mt-2"
                      style={{ backgroundColor: `${action?.color}30` }}
                    />
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Tasks Tab */}
          {activeTab === 'tasks' && (
            <div className="space-y-3">
              <div className="flex items-center gap-2 mb-4">
                <Icon name="CheckSquare" size={18} color={action?.color} />
                <h4 className="text-lg font-semibold text-white">المهام المطلوبة</h4>
              </div>
              {actionDetails?.tasks?.map((task) => (
                <div 
                  key={task?.id}
                  className="bg-gradient-to-br from-gray-800/80 to-gray-800/40 rounded-xl p-4 border border-gray-700/50 hover:border-gray-600/50 transition-all duration-200 cursor-pointer group"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3 flex-1">
                      <div 
                        className="w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm shadow-md"
                        style={{
                          backgroundColor: `${getPriorityColor(task?.priority)}20`,
                          color: getPriorityColor(task?.priority)
                        }}
                      >
                        {task?.count}
                      </div>
                      <div className="flex-1">
                        <h5 className="text-white font-medium group-hover:text-gray-200 transition-colors">
                          {task?.title}
                        </h5>
                        <div className="flex items-center gap-2 mt-1">
                          <span 
                            className="px-2 py-0.5 rounded-full text-xs font-medium"
                            style={{
                              backgroundColor: `${getPriorityColor(task?.priority)}20`,
                              color: getPriorityColor(task?.priority)
                            }}
                          >
                            {task?.priority === 'urgent' ? 'عاجل' : task?.priority === 'high' ? 'عالي' : task?.priority === 'medium' ? 'متوسط' : 'منخفض'}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Icon name="ChevronLeft" size={18} color="#6B7280" className="group-hover:text-gray-400 transition-colors" />
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Options Tab */}
          {activeTab === 'options' && (
            <div className="space-y-3">
              <div className="flex items-center gap-2 mb-4">
                <Icon name="Settings" size={18} color={action?.color} />
                <h4 className="text-lg font-semibold text-white">الخيارات المتاحة</h4>
              </div>
              <div className="grid grid-cols-2 gap-3">
                {actionDetails?.options?.map((option) => (
                  <button
                    key={option?.id}
                    onClick={() => {
                      // Handle different actions based on box type
                      if (action?.id === 'draft-creation' && option?.action === 'create_draft') {
                        setShowNewContractModal(true);
                      } else if (action?.id === 'legal-review' && option?.action === 'start_review') {
                        setShowLegalReviewModal(true);
                      } else if (action?.id === 'legal-review' && option?.action === 'compliance_check') {
                        console.log('Running compliance check...');
                        alert('تم التحقق من جميع الشروط متوافقة مع القوانين المحلية ✓');
                      } else if (action?.id === 'approval' && option?.action === 'approve') {
                        setShowApprovalModal(true);
                      } else if (action?.id === 'approval' && option?.action === 'reject') {
                        if (confirm('هل أنت متأكد من رفض هذا العقد؟')) {
                          console.log('Contract rejected');
                          alert('تم رفض العقد وإرسال إشعار للفريق');
                        }
                      } else if (action?.id === 'digital-signing' && option?.action === 'send_for_signature') {
                        setShowDigitalSigningModal(true);
                      } else if (action?.id === 'digital-signing' && option?.action === 'verify_signature') {
                        console.log('Verifying signatures...');
                        alert('تم التحقق من جميع التوقيعات الإلكترونية ✓');
                      } else if (action?.id === 'execution' && option?.action === 'activate_contract') {
                        setShowExecutionModal(true);
                      } else if (action?.id === 'execution' && option?.action === 'schedule_payments') {
                        setShowExecutionModal(true);
                      } else if (action?.id === 'renewal' && option?.action === 'start_renewal') {
                        setShowRenewalModal(true);
                      } else if (action?.id === 'renewal' && option?.action === 'contact_client') {
                        console.log('Contacting client for renewal...');
                        alert('تم إرسال رسالة للعميل لمناقشة تجديد العقد');
                      } else if (action?.id === 'termination' && option?.action === 'start_termination') {
                        setShowTerminationModal(true);
                      } else if (action?.id === 'termination' && option?.action === 'calculate_settlement') {
                        setShowTerminationModal(true);
                      } else if (action?.id === 'archive' && option?.action === 'archive') {
                        console.log('Archiving contract...');
                        alert('تم أرشفة العقد بنجاح في النظام الآمن');
                      } else if (action?.id === 'archive' && option?.action === 'search_archive') {
                        setShowArchiveModal(true);
                      } else {
                        console.log(`Action: ${option?.action}`);
                      }
                    }}
                    className="bg-gradient-to-br from-gray-800/80 to-gray-800/40 rounded-xl p-4 border border-gray-700/50 hover:border-gray-600/50 transition-all duration-200 group hover:scale-105 active:scale-95"
                  >
                    <div className="flex flex-col items-center gap-3">
                      <div 
                        className="p-3 rounded-xl shadow-md transition-all group-hover:scale-110"
                        style={{ 
                          backgroundColor: `${action?.color}20`,
                          boxShadow: `0 4px 12px ${action?.color}30`
                        }}
                      >
                        <Icon name={option?.icon} size={24} color={action?.color} />
                      </div>
                      <span className="text-white font-medium text-sm text-center">{option?.label}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* New Contract Modal */}
      {showNewContractModal && setShowNewContractModal && (
        <NewContractModal 
          isOpen={showNewContractModal}
          onClose={() => setShowNewContractModal(false)}
          actionColor={action?.color}
          contractTypeConfig={contractTypeConfig}
        />
      )}

      {/* Legal Review Modal */}
      {showLegalReviewModal && (
        <LegalReviewModal 
          isOpen={showLegalReviewModal}
          onClose={() => setShowLegalReviewModal(false)}
          contract={selectedContract}
          actionColor={action?.color}
        />
      )}

      {/* Approval Modal */}
      {showApprovalModal && (
        <ApprovalModal 
          isOpen={showApprovalModal}
          onClose={() => setShowApprovalModal(false)}
          contract={selectedContract}
          actionColor={action?.color}
        />
      )}

      {/* Digital Signing Modal */}
      {showDigitalSigningModal && (
        <DigitalSigningModal 
          isOpen={showDigitalSigningModal}
          onClose={() => setShowDigitalSigningModal(false)}
          contract={selectedContract}
          actionColor={action?.color}
        />
      )}

      {/* Execution Modal */}
      {showExecutionModal && (
        <ExecutionModal 
          isOpen={showExecutionModal}
          onClose={() => setShowExecutionModal(false)}
          contract={selectedContract}
          actionColor={action?.color}
        />
      )}

      {/* Renewal Modal */}
      {showRenewalModal && (
        <RenewalModal 
          isOpen={showRenewalModal}
          onClose={() => setShowRenewalModal(false)}
          contract={selectedContract}
          actionColor={action?.color}
        />
      )}

      {/* Termination Modal */}
      {showTerminationModal && (
        <TerminationModal 
          isOpen={showTerminationModal}
          onClose={() => setShowTerminationModal(false)}
          contract={selectedContract}
          actionColor={action?.color}
        />
      )}

      {/* Archive Modal */}
      {showArchiveModal && (
        <ArchiveModal 
          isOpen={showArchiveModal}
          onClose={() => setShowArchiveModal(false)}
          contract={selectedContract}
          actionColor={action?.color}
        />
      )}
    </>
  );
};

const ActionBoxes = ({ actions, showNewContractModal, setShowNewContractModal, contractTypeConfig }) => {
  const [selectedAction, setSelectedAction] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

  const defaultActions = [
    {
      id: 'draft-creation',
      label: 'إنشاء المسودات',
      icon: 'FilePlus',
      color: '#8B5CF6',
      borderColor: 'rgba(139, 92, 246, 0.5)',
      bgGradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(167, 139, 250, 0.35) 100%)'
    },
    {
      id: 'legal-review',
      label: 'المراجعة القانونية',
      icon: 'Scale',
      color: '#EC4899',
      borderColor: 'rgba(236, 72, 153, 0.5)',
      bgGradient: 'linear-gradient(135deg, rgba(236, 72, 153, 0.3) 0%, rgba(244, 114, 182, 0.35) 100%)'
    },
    {
      id: 'approval',
      label: 'الموافقة والاعتماد',
      icon: 'ThumbsUp',
      color: '#10B981',
      borderColor: 'rgba(16, 185, 129, 0.5)',
      bgGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.3) 0%, rgba(52, 211, 238, 0.35) 100%)'
    },
    {
      id: 'digital-signing',
      label: 'التوقيع الإلكتروني',
      icon: 'PenTool',
      color: '#3B82F6',
      borderColor: 'rgba(59, 130, 246, 0.5)',
      bgGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.3) 0%, rgba(96, 165, 250, 0.35) 100%)'
    },
    {
      id: 'execution',
      label: 'التنفيذ والمتابعة',
      icon: 'Play',
      color: '#F59E0B',
      borderColor: 'rgba(245, 158, 11, 0.5)',
      bgGradient: 'linear-gradient(135deg, rgba(245, 158, 11, 0.3) 0%, rgba(251, 191, 36, 0.35) 100%)'
    },
    {
      id: 'renewal',
      label: 'التجديد والتحديث',
      icon: 'RefreshCw',
      color: '#06B6D4',
      borderColor: 'rgba(6, 182, 212, 0.5)',
      bgGradient: 'linear-gradient(135deg, rgba(6, 182, 212, 0.3) 0%, rgba(34, 211, 238, 0.35) 100%)'
    },
    {
      id: 'termination',
      label: 'الإنهاء والإلغاء',
      icon: 'XCircle',
      color: '#EF4444',
      borderColor: 'rgba(239, 68, 68, 0.5)',
      bgGradient: 'linear-gradient(135deg, rgba(239, 68, 68, 0.3) 0%, rgba(248, 113, 113, 0.35) 100%)'
    },
    {
      id: 'archive',
      label: 'الأرشفة والتخزين',
      icon: 'Archive',
      color: '#6B7280',
      borderColor: 'rgba(107, 114, 128, 0.5)',
      bgGradient: 'linear-gradient(135deg, rgba(107, 114, 128, 0.3) 0%, rgba(156, 163, 175, 0.35) 100%)'
    }
  ];

  const handleActionClick = (action, event) => {
    const rect = event?.currentTarget?.getBoundingClientRect();
    setPopupPosition({
      x: rect?.left + rect?.width / 2,
      y: rect?.top + rect?.height / 2
    });
    setSelectedAction(action);
  };

  // Use provided actions or default actions
  const displayActions = actions || defaultActions;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
      {displayActions?.map((action, index) => (
        <button
          key={index}
          onClick={(e) => handleActionClick(action, e)}
          className="group relative bg-gradient-to-br from-gray-900 to-gray-800 border-2 rounded-2xl p-5 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 cursor-pointer"
          style={{
            borderColor: action?.borderColor || 'rgba(59, 130, 246, 0.5)',
            boxShadow: `0 10px 40px ${action?.color || '#3B82F6'}20`
          }}
        >
          {/* Icon */}
          <div 
            className="w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg"
            style={{
              background: action?.bgGradient || 'linear-gradient(135deg, rgba(59, 130, 246, 0.3) 0%, rgba(96, 165, 250, 0.35) 100%)'
            }}
          >
            <Icon name={action?.icon} size={28} color={action?.color || '#3B82F6'} />
          </div>

          {/* Title */}
          <h3 className="text-base font-bold text-white mb-2 group-hover:text-opacity-90 transition-all text-center">
            {action?.label}
          </h3>

          {/* Arrow Icon */}
          <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity">
            <Icon name="ArrowLeft" size={18} color={action?.color || '#3B82F6'} />
          </div>
        </button>
      ))}

      {/* Action Box Popup */}
      {selectedAction && (
        <ActionBoxPopup 
          action={selectedAction}
          onClose={() => setSelectedAction(null)}
          position={popupPosition}
        />
      )}
    </div>
  );
};

export default ActionBoxes;